import { FormQuestionType, FormResponse } from '../types/forms';

const singleFreeTextResponse: FormResponse[] = [
  {
    type: 'freeText',
    key: 'response',
  },
];

const journalDoubleFieldResponse: FormResponse[] = [
  {
    type: 'numberedText',
    key: 'mostImportant',
  },
  {
    type: 'numberedText',
    key: 'leastImportant',
  },
];

const pillarSurveyNumbersPickerWithout7 = (questionKey: string): FormResponse[] => [
  {
    key: `${questionKey}-response`,
    type: 'numbersPickerWithout7',
    options: [1, 2, 3, 4, 5, 6, 8, 9, 10].map((item) => ({ value: `${item}`, text: `${item}` })),
  },
];

export const getFormResponseTypeAndKeys = (
  questionType: FormQuestionType,
  responsesNumber?: number,
  questionKey?: string,
): FormResponse[] => {
  switch (questionType) {
    case 'reflection':
      return singleFreeTextResponse;
    case 'journal':
      switch (responsesNumber) {
        case 1:
          return singleFreeTextResponse;
        case 2:
          return journalDoubleFieldResponse;
        default:
          return [];
      }
    case 'pillarSurvey':
      return pillarSurveyNumbersPickerWithout7(questionKey || 'pillarSurvey');
    default:
      return [];
  }
};
